import React from 'react';
import { useDispatch } from 'react-redux';
import { setIsLoggedIn, setUserInfo2 } from "../reduxToolkit/redux";
import { useNavigate } from 'react-router-dom';
import { FaApple } from 'react-icons/fa';
import { signInWithPopup, OAuthProvider } from 'firebase/auth';
import { auth } from '../page_firebase/firebaseConfig';
import fnc from '../mymod/commFunction';

function AppleLogin({ loading, setLoading }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleAppleLogin = async () => {
        setLoading(true);
        try {
            const provider = new OAuthProvider('apple.com');
            
            provider.addScope('email');
            provider.addScope('name');
            
            provider.setCustomParameters({
                locale: 'ko_KR'
            });
            
            const result = await signInWithPopup(auth, provider);
            const user = result.user;

            // Apple 로그인은 displayName이 제공되지 않을 수 있으므로 email의 local 부분을 사용
            const displayName = user.displayName || user.email?.split('@')[0] || 'Apple 사용자';

            fncInsertSocialLogin('APPLE', user.uid, displayName, user.photoURL || '');

            
        } catch (error) {
            let errorMessage = 'Apple 로그인에 실패했습니다.';
            
            if (error.code === 'auth/popup-closed-by-user') {
                errorMessage = 'Apple 로그인이 취소되었습니다.';
            } else if (error.code === 'auth/popup-blocked') {
                errorMessage = '팝업이 차단되었습니다. 팝업을 허용하고 다시 시도해주세요.';
            } else if (error.code === 'auth/cancelled-popup-request') {
                errorMessage = '이미 진행 중인 로그인이 있습니다.';
            } else if (error.code === 'auth/network-request-failed') {
                errorMessage = '네트워크 연결을 확인하고 다시 시도해주세요.';
            } else if (error.code === 'auth/internal-error') {
                errorMessage = '내부 오류가 발생했습니다. Firebase 설정을 확인해주세요.';
            } else if (error.code === 'auth/unauthorized-domain') {
                errorMessage = '승인되지 않은 도메인입니다. Firebase 콘솔에서 도메인을 승인해주세요.';
            } else if (error.code === 'auth/operation-not-allowed') {
                errorMessage = 'Firebase에서 Apple 인증이 활성화되지 않았습니다. Firebase 콘솔에서 Apple 제공업체를 활성화해주세요.';
            } else if (error.code === 'auth/invalid-credential') {
                errorMessage = 'Apple 인증 정보가 유효하지 않습니다.';
            } else if (error.code === 'auth/account-exists-with-different-credential') {
                errorMessage = '이미 다른 로그인 방법으로 등록된 계정입니다.';
            }
            
            alert(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    function fncInsertSocialLogin(acaCode, id, nickname, profile_image) {
            fnc.sendAxios('/kuesbLoginRoutes/insert/socialLogin', { acaCode, id, nickname, profile_image, isSocialLogin: 'Y' }, (res) => {
                if (res.success) {
                    fncSelectSocialLogin(id);
                } else {
                alert('저장에 실패했습니다.');
                }
            });
        }
    
        function fncSelectSocialLogin(id) {
            fnc.sendAxios('/kuesbLoginRoutes/select/socialLogin', { id }, (res) => {
                if (res && res.length > 0) {
                    dispatch(setUserInfo2({
                        acaCode: res[0].acaCode || '',
                        nickname: res[0].nickname || '',
                        email: res[0].email || '',
                        id: res[0].id || '',
                        id2: res[0].id2 || '',
                        profile_image: res[0].profile_image || '',
                        uid: res[0].uid || ''
                    }));
    
                    dispatch(setIsLoggedIn(true));
                    navigate('/menu');
                } else {
                    alert('정보가 올바르지 않습니다.');
                }
            });
        }

    //=========================================================
    return (
        <button 
            className="social-btn apple-btn" 
            onClick={handleAppleLogin}
            disabled={loading}
        >
            <FaApple className="social-icon" />
            <span>Apple로 로그인</span>
        </button>
    );
}

export default AppleLogin;